import SundayService from "../DTOs/SundayService";

/**
 * A preacher's own answer to a slot, set through "Meine Termine": they cannot
 * come ("declined") or asked a colleague to take it ("swap-pending"). Mirrors
 * getSlotStatus in functions/src/serviceSlots.ts.
 */
export type SlotAlert = "declined" | "swap-pending";

type SlotStatusFields = Pick<
    SundayService,
    | "sermon1PreacherKey"
    | "sermon1Status"
    | "sermon1StatusPreacherKey"
    | "sermon1DeclineReason"
    | "sermon2PreacherKey"
    | "sermon2Status"
    | "sermon2StatusPreacherKey"
    | "sermon2DeclineReason"
>;

/**
 * The alert on a slot, or null. A stored status only counts for the preacher it
 * was set for: once someone else is assigned it no longer applies.
 */
export function getSlotAlert(service: SlotStatusFields, slot: 1 | 2): SlotAlert | null {
    const preacherKey = slot === 1 ? service.sermon1PreacherKey : service.sermon2PreacherKey;
    const status = slot === 1 ? service.sermon1Status : service.sermon2Status;
    const statusFor = slot === 1 ? service.sermon1StatusPreacherKey : service.sermon2StatusPreacherKey;
    if (!preacherKey || statusFor !== preacherKey) return null;
    return status === "declined" || status === "swap-pending" ? status : null;
}

/** The reason the preacher gave when declining, or "". */
export function getDeclineReason(service: SlotStatusFields, slot: 1 | 2): string {
    if (getSlotAlert(service, slot) !== "declined") return "";
    return (slot === 1 ? service.sermon1DeclineReason : service.sermon2DeclineReason) ?? "";
}
